import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import WBSTreeItem, { countFilteredWbsActivities } from './WBSTreeItem.jsx';

export default class WBSTree extends React.Component {
	// WARNING: Check this function if the component is not updating when you need it to
	shouldComponentUpdate(nextProps, nextState) {
		return this.props.isBulkActive !== nextProps.isBulkActive ||
			JSON.stringify(this.props.bulkActivities) !== JSON.stringify(nextProps.bulkActivities) ||
			JSON.stringify(this.props.filteredActivitiesMap) !== JSON.stringify(nextProps.filteredActivitiesMap) ||
			JSON.stringify(this.props.filteredActivities) !== JSON.stringify(nextProps.filteredActivities);
	}

	render() {
		const { wbsData, filteredActivities, filteredActivitiesMap, datasetInfo } = this.props;

		if (wbsData === null) {
			return (
				<div>Please select a project to view the WBS List</div>
			);
		}

		let filteredActivityCountSum = 0;
		const wbsTree = [];

		for (const wbsId in wbsData) {
			const wbsItem = wbsData[wbsId];
			const filteredCount = countFilteredWbsActivities(
				wbsItem,
				filteredActivitiesMap,
				filteredActivities
			);
			if (!filteredCount) {
				continue;
			}
			filteredActivityCountSum += filteredCount;
			wbsTree.push(
				<ListGroupItem key={wbsId}>
					<WBSTreeItem
						wbsItem={wbsItem}
						filteredActivities={filteredActivities}
						filteredActivitiesMap={filteredActivitiesMap}
						datasetInfo={datasetInfo} />
				</ListGroupItem>
			);
		}

		if (filteredActivityCountSum === 0) {
			return <div>All of your activities have been filtered.</div>;
		}

		return (
			<Panel
				defaultExpanded
				className="swaTree">
				<Panel.Heading>
					<Panel.Title toggle>WBS List</Panel.Title>
				</Panel.Heading>
				<ListGroup className="top-level">
					{wbsTree}
				</ListGroup>
			</Panel>
		);
	}
}

WBSTree.propTypes = {
	wbsData: PropTypes.object,
	filteredActivities: PropTypes.array,
	filteredActivitiesMap: PropTypes.object,
	datasetInfo: PropTypes.object,
	isBulkActive: PropTypes.bool,
	bulkActivities: PropTypes.array
};
